import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { env } from "../../../env/env";
import { AppService } from "../../core/app.service";
import { ApiResponse } from "../../data/http/responses/apiresponse.response";

export interface UploadLogoResponse {
  path: string;
}

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private baseUrl = `${env.apiUrl}upload`;

  constructor(private http: HttpClient, private appService: AppService) {}

  uploadLogo(file: File): Observable<UploadLogoResponse> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<ApiResponse<UploadLogoResponse>>(`${this.baseUrl}/logo`, formData)
      .pipe(
        switchMap(res => {
          if (!res.success || !res.data) {
            return throwError(() => new Error(res.message || 'Échec de l\'upload'));
          }
          return [res.data as UploadLogoResponse];
        })
      );
  }
}